// swatches-auto.js — priorità: metafield HEX -> image sampling -> name -> neutral
document.addEventListener('DOMContentLoaded', function () {

  function isHexColor(s) {
    if (!s) return false;
    s = s.trim();
    return /^#?([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(s);
  }
  function normalizeHex(s){
    s = s.trim();
    if (s[0] !== '#') return '#' + s;
    return s;
  }
  function nameToHsl(name) {
    var h = 0;
    for (var i = 0; i < name.length; i++) {
      h = name.charCodeAt(i) + ((h << 5) - h);
    }
    h = Math.abs(h) % 360;
    return 'hsl(' + h + ', 62%, 60%)';
  }
  function rgbToHex(r,g,b){
    return "#" + [r,g,b].map(function(x){
      var h = x.toString(16);
      return h.length===1 ? "0"+h : h;
    }).join('');
  }

  function sampleImageAverageColor(url) {
    return new Promise(function(resolve, reject){
      if (!url) return reject('no-url');
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function(){
        try {
          var canvas = document.createElement('canvas');
          var w = 16, h = 16;
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          var data = ctx.getImageData(0,0,w,h).data;
          var r=0,g=0,b=0,count=0;
          for (var i=0;i<data.length;i+=4){
            if (data[i+3] === 0) continue;
            r += data[i]; g += data[i+1]; b += data[i+2]; count++;
          }
          if (count === 0) return reject('no-pixels');
          r = Math.round(r/count); g = Math.round(g/count); b = Math.round(b/count);
          resolve(rgbToHex(r,g,b));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = function(e){
        reject(e);
      };
      img.src = url;
      if (img.complete) img.onload();
    });
  }

  document.querySelectorAll('.product-card__variants.auto-swatch').forEach(function (container) {
    container.style.display = 'flex';
    container.style.justifyContent = 'center'; // Centra i pallini orizzontalmente
    container.style.flexWrap = 'wrap';       // Se sono tanti, vanno a capo invece di rompere la card
    container.style.gap = '8px';               // Spazio tra un pallino e l'altro
    container.style.margin = '10px auto';
    
    container.querySelectorAll('.swatch-card').forEach(function (el) {
      var img = el.dataset.imageUrl;
      var val = (el.dataset.colorValue || '').trim();
      var mfHex = (el.dataset.colorHex || '').trim();

      // 1) se esiste metafield esatto, usalo subito
      if (mfHex && isHexColor(mfHex)) {
        el.style.backgroundColor = normalizeHex(mfHex);
        return;
      }

      // 2) se c'è immagine prova a campionare
      if (img && img.trim().length) {
        sampleImageAverageColor(img).then(function(hex){
          el.style.backgroundColor = hex;
          el.classList.add('swatch-card--image');
        }).catch(function(err){
          // sampling fallito (CORS o altro) -> fallback ai metodi testuali
          applyTextFallback(el, val);
        });
        return;
      }

      // 3) fallback testuale
      applyTextFallback(el, val);
    });
  });

  function applyTextFallback(el, val){
    var low = (val || '').toLowerCase();
    if (isHexColor(val)) {
      el.style.backgroundColor = normalizeHex(val);
      return;
    } else if (low.indexOf('rgb(') === 0 || low.indexOf('rgba(') === 0 || low.indexOf('hsl(') === 0) {
      el.style.backgroundColor = val;
      return;
    } else if (val.length) {
      el.style.backgroundColor = nameToHsl(val);
      return;
    }
    el.style.backgroundColor = '#eee';
  }

});
